import React from 'react';

export default function InvoiceListItem({invoiceNumber, isActive, onSelect})
{
    return (
        <a href="#" onClick={(event) => {event.preventDefault(); onSelect(invoiceNumber)}} className="list-group-item list-group-item-action {isActive && 'active'}">
            {invoiceNumber}
        </a>
    );
}